import React, { useRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useHttp from "../../../../hooks/use-http";
import convertToExcel from "../../../../components/ExportToExcel";
import Pagination from "../../../../components/Pagination";
import { AutoComplete } from "antd";

const HubSalesReport = () => {
  const frmRef = useRef({});
  const navigate = useNavigate();
  const handleButtonClick = () => {
    navigate("/agrimis");
  };

  const [employeeId, setEmployeeId] = useState(0);
  const [employeeData, setEmployeeData] = useState([]);
  const [regionData, setRegionData] = useState([]);
  const [employeeAllData, setEmployeeAllData] = useState([]);
  const [regionId, setRegionId] = useState();
  const [farmerNumber, setFarmerNumber] = useState("");
  const [farmerData, setFarmerData] = useState();
  const [showDateFilter, setShowDateFilter] = useState(false);
  const [warehosuedata, setWarehosuedata] = useState([]);
  const [warehouseId, setWarehouseId] = useState();

  const handleDateFilterChange = (e) => {
    setShowDateFilter(e.target.value === "Yes");
  };

  const [data, setData] = useState([]);

  const itemsPerPage = localStorage.getItem("pageSize") || 10;
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleFDateChange = (e) => {
    //console.log("handleFDateChange", e.target.value);
    setSelectedFromDate(e.target.value);
    setData([]);
  };
  const handleTDateChange = (e) => {
    setSelectedToDate(e.target.value);
    setData([]);
  };

  // var date =date.setDate(date.getDate() + 10);

  const currentDate = new Date().toISOString().slice(0, 10);
  var d = new Date();
  d.setDate(d.getDate() - 30);

  const fromDate = d.toISOString().slice(0, 10);
  const [selectedFromDate, setSelectedFromDate] = useState(fromDate);

  const toDate = new Date().toISOString().slice(0, 10);

  //console.log("toDate", toDate);

  const [selectedToDate, setSelectedToDate] = useState(toDate);

  const { sendRequest: getTemplateData } = useHttp();

  const fillTemplateData = (employeeId) => {
    var urlfilter = "";

    if (showDateFilter) {
      urlfilter = urlfilter + `&fromDate=${selectedFromDate}`;
      urlfilter = urlfilter + `&toDate=${selectedToDate}`;
    }

    if (employeeId > 0) {
      urlfilter = urlfilter + `&fieldExecutiveId=${employeeId}`;
    }

    // if (warehouseId > 0) {
    //   urlfilter = urlfilter + `&warehouseId=${warehouseId}`;
    // }

    // if (regionId > 0) {
    //   urlfilter = urlfilter + `&regionId=${regionId}`;
    // }
    // if (farmerNo != "") {
    //   urlfilter = urlfilter + `&farmerNo=${farmerNo}`;
    // }

    var url = `/api/hubSalesReport/?orgId=${localStorage.getItem(
      "orgId"
    )}&empId=${localStorage.getItem("empId")}${urlfilter}`;

    getTemplateData(
      {
        url: url,
      },
      (data) => {
        console.log("reportdata", data);
        setData(data);
      }
    );
  };

  useEffect(() => {
    fillTemplateData(0, 0, "");
  }, [getTemplateData]);

  const concatenateDetails = (details, field) => {
    return details.map((detail) => detail[field] || "").join(" \n ");
  };

  const parseDMYDate = (dmy) => {
    if (!dmy || typeof dmy !== "string") return "NA";
    const [day, month, year] = dmy.split("/");
    const date = new Date(`${year}-${month}-${day}`);
    return isNaN(date.getTime()) ? "NA" : date.toLocaleDateString("en-GB");
  };

  const prepareDataForExcel = (tableData) => {
    return tableData.map((item) => ({
      CustomerID: item.docNo,
      hubSalesDate: parseDMYDate(item.hubSalesDate),
      participantName: item.participantName,
      hubName:item.hubName,
      employeeName:item.employeeName,
      ageRange: item.ageRange,
      gender: item.gender,
      maritalStatus: item.maritalStatus,
      categoryOfBuyers: item.categoryOfBuyers,
      annualIncome: item.annualIncome,
      mobileNumber: item.mobileNumber,
      lga: item.lga,
      state: item.state,
      address: item.address,
      salesOrderNumber: item.salesOrderNumber,
      orderDate: parseDMYDate(item.orderDate),
      actualPurchaseDate: parseDMYDate(item.actualPurchaseDate),
      farmSizedHa: item.farmSizedHa,
      educationLevel: item.educationLevel,
      usage: item.usage,
      paymentMode: item.paymentMode,
      deliveryNeeded: item.deliveryNeeded,
      productDestinationState: item.productDestinationState,
      productDestinationLocality: item.productDestinationLocality,
      farmerFeedback: item.farmerFeedback,
      followUp: item.followUp,
      createdDate: parseDMYDate(item.createdDate),
      cropTypeName: item.cropTypeName,
      productName: item.productName,
      productType: item.productTypeName,
      productSKU: item.productSKU,
      itemQuantity: item.itemQuantity,
      unit: item.unit,
      unitPrice: item.unitPrice,
      totalAmount: item.totalAmount,
    }));
  };

  const fieldsToExport = [
    "CustomerID",
    "hubSalesDate",
    "hubName",
    "employeeName",
    "participantName",
    "ageRange",
    "gender",
    "maritalStatus",
    "categoryOfBuyers",
    "annualIncome",
    "mobileNumber",
    "educationLevel",
    "state",
    "lga",
    "address",
    // "farmSizedHa",
    // "cropTypeName",
    "salesOrderNumber",
    "orderDate",
    "actualPurchaseDate",
    "productType",
    "productName",
    "productSKU",
    "itemQuantity",
    "unit",
    "unitPrice",
    "totalAmount",
    "usage",
    "paymentMode",
    "deliveryNeeded",
    "productDestinationState",
    "productDestinationLocality",
    "farmerFeedback",
    "followUp",
    "createdDate",
  ];

  const customHeaders = [
    "Customer ID",
    "Hub Sales Date",
    "Hub Name",
    "Agripromoter Name",
    "Full Name",
    "Age Range",
    "Gender",
    "Marital Status",
    "Buyers Category",
    "Annual Income",
    "Mobile Number",
    "Education Level",
    "State",
    "LGA",
    "Address",
    // "Farm Size (Ha)",
    // "Crop Type",
    "Sales Order No",
    "Order Date",
    "Date of Actual Purchase",
    "Product Type",
    "Product",
    "Product SKU",
    "Quantity Sold",
    "Unit",
    "Unit Price(N)",
    "Total Amount(N)",
    "Usage",
    "Payment Mode",
    "Delivery Needed(Yes/No)",
    "Product Destination State",
    "Product Destination Locality",
    "Buyers Feedback/Remark",
    "Follow-Up Needed(Yes/No)",
    "Created Date",
  ];

  const preparedData = prepareDataForExcel(data);

  const handleExportExcel = () => {
    const filename = "HubSalesReport.xlsx";
    // console.log(fieldsToExport, customHeaders);

    convertToExcel(preparedData, fieldsToExport, filename, customHeaders);
  };

  //   const { sendRequest: getWarehouseData } = useHttp();

  //   const getWarehouseDetail = () => {
  //     getWarehouseData(
  //       {
  //         url: "/api/warehouses/",
  //       },
  //       (res) => {
  //         if (res) {
  //           setWarehosuedata(res);
  //         }
  //       }
  //     );
  //   };

  //   useEffect(() => {
  //     getWarehouseDetail();
  //   }, [getWarehouseData]);

  const { sendRequest: getEmp } = useHttp();

  const EmployeeDetail = (region) => {
    var urlfilter = "";

    if (region > 0) {
      urlfilter = urlfilter + `&regionId=${region}`;
    }
    getEmp(
      {
        url: `/api/employeeListForProcReort/?useCase=Agri Promoter&empId=${localStorage.getItem(
          "empId"
        )}&orgId=${localStorage.getItem("orgId")}${urlfilter} `,
      },
      (data) => {
        // console.log("emp", data);
        var emplist = data;

        setEmployeeData(emplist);
        //   setEmployeeAllData(emplist);
      }
    );
  };

  useEffect(() => {
    EmployeeDetail(0);
  }, [getEmp]);

  // const { sendRequest: getFarmerNumber } = useHttp();
  // useEffect(() => {
  //   getFarmerNumber(
  //     {
  //       url: `/api/farmerNumberList/?orgId=${localStorage.getItem(
  //         "orgId"
  //       )}&fieldExecutiveId=${employeeId}`,
  //     },
  //     (data) => {
  //       console.log("farmerNumberList", data);

  //       setFarmerData(data);
  //     }
  //   );
  // }, [employeeId]);

  // const handleSearch = (value) => {
  //   setFarmerNumber(value);
  // };


  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          {" "}
          <div className="col-md-8 mt-3">
            {" "}
            <label className="card-title">Hub Sales Report</label>
          </div>
          <div className="col-md-4 text-right mt-3">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              onClick={handleButtonClick}
            >
              <i className="fas fa-times" />
            </button>
          </div>
        </div>
        <br />
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-3">
                <div className="form-group">
                  <label htmlFor={"executive_officer"}>
                    {"Executive Officer"}
                  </label>
                  <select
                    id="emp_id"
                    className="form-control"
                    ref={(el) => (frmRef.current["emp_id"] = el)}
                    value={employeeId}
                    onChange={(e) => {
                      var userid = 0;
                      if (e.target.value != "--Select--")
                        userid = e.target.value;

                      setEmployeeId(userid);
                      setData([]);
                    }}
                  >
                    <option value="0">Select</option>
                    {employeeData &&
                      employeeData.map((x) => (
                        <option
                          key={x.userId}
                          user-id={x.userId}
                          value={x.userId}
                        >
                          {x.employeeName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  {" "}
                  <label htmlFor={"date_filter"}>{"Apply Date Filter"}</label>
                  <select
                    id="date_filter"
                    className="form-control"
                    ref={(el) => (frmRef.current["date_filter"] = el)}
                    onChange={handleDateFilterChange}
                  >
                    <option value="">Select</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>
              </div>
              {showDateFilter && (
                <>
                  <div className="col-md-3">
                    <div className="form-group">
                      {" "}
                      <label htmlFor={"from_date"}>{"From Date"}</label>
                      <input
                        type={"date"}
                        id={"date"}
                        required
                        // ref={(el) => (frmRef.current["pdate"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedFromDate}
                        onChange={handleFDateChange}
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label htmlFor={"to_date"}>{"To Date"}</label>

                      <input
                        type={"date"}
                        id={"date"}
                        required
                        // ref={(el) => (frmRef.current["pdate"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedToDate}
                        onChange={handleTDateChange}
                      />
                    </div>
                  </div>
                </>
              )}
            </div>
            <div className="row">
              <div className="col-md-3  text-right">
                <div className="form-group">
                  <label>&nbsp;</label>
                  <button
                    className="form-control btn btn-sm btn-primary"
                    onClick={(e) => {
                      fillTemplateData(employeeId);
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
          <h5>Please select the parameters to get the desired result</h5>
          <hr />
        </section>

        <section className="content">
          <div className="container-fluid">
            <div className="text-right my-2">
              <button
                type="button"
                className="btn btn-sm btn-warning"
                onClick={handleExportExcel}
              >
                <i className="fas fa-file-excel"></i>
              </button>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <table className="table table-bordered table-responsive text-center table-sm">
                      <thead>
                        <tr className="table-header">
                          <th>Sr. No</th>
                          <th>Customer ID</th>
                          <th>Hub Sales Date</th>
                          <th>Hub Name</th>
                          <th>Agripromoter Name</th>
                          <th>Full Name</th>
                          <th>Age Range</th>
                          <th>Gender</th>
                          <th>Marital Status</th>
                          <th>Buyers Category</th>
                          <th>Annual Income</th>
                          <th>Mobile Number</th>
                          <th>Education Level</th>
                          <th>State</th>
                          <th>LGA</th>
                          <th>Address</th>
                          {/* <th>Farm Size (Ha)</thh> */}
                          {/* <th>Crop Type</th> */}
                          <th>Sales Order No</th>
                          <th>Order Date</th>
                          <th>Date of Actual Purchase</th>
                          <th>Product Type</th>
                          <th>Product</th>
                          <th>Product SKU</th>
                          <th>Quantity Sold</th>
                          <th>Unit</th>
                          <th>Unit Price(N)</th>
                          <th>Total Amount(N)</th>
                          <th>Usage</th>
                          <th>Payment Mode</th>
                          <th>Delivery Needed</th>
                          <th>Product Destination State</th>
                          <th>Product Destination Locality</th>
                          <th>Buyer's Feedback/Remark</th>
                          <th>Follow-Up</th>
                          <th>Created Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentItems &&
                          currentItems.map((item, index) => (
                            <tr key={`row-${index}`}>
                              <td>{index + 1}</td>
                              <td>{item.docNo}</td>
                              <td>{parseDMYDate(item.hubSalesDate)}</td>
                              <td>{item.hubName}</td>
                              <td>{item.employeeName}</td>                              
                              <td>{item.participantName}</td>
                              <td>{item.ageRange}</td>
                              <td>{item.gender}</td>
                              <td>{item.maritalStatus}</td>
                              <td>{item.categoryOfBuyers}</td>
                              <td>{item.annualIncome}</td>
                              <td>{item.mobileNumber}</td>
                              <td>{item.educationLevel}</td>
                              <td>{item.state}</td>
                              <td>{item.lga}</td>
                              <td>{item.address}</td>
                              {/* <td>{item.farmSizedHa}</td> */}
                              {/* <td>{item.cropTypeName}</td> */}
                              <td>{item.salesOrderNumber}</td>
                              <td>{parseDMYDate(item.orderDate)}</td>
                              <td>{parseDMYDate(item.actualPurchaseDate)}</td>
                              <td>{item.productTypeName}</td>
                              <td>{item.productName}</td>
                              <td>{item.productSKU}</td>
                              <td>{item.itemQuantity}</td>
                              <td>{item.unit}</td>
                              <td>{item.unitPrice}</td>
                              <td>{item.totalAmount}</td>
                              <td>{item.usage}</td>
                              <td>{item.paymentMode}</td>
                              <td>{item.deliveryNeeded}</td>
                              <td>{item.productDestinationState}</td>
                              <td>{item.productDestinationLocality}</td>
                              <td>{item.farmerFeedback}</td>
                              <td>{item.followUp}</td>
                              <td>{item.createdDate ? parseDMYDate(item.createdDate.split(" ")[0]) : "NA"}</td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>

                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default HubSalesReport;
